import { Fragment, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UIPaginator from 'UIComponents/paginator/UIPaginator';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { useCollections } from 'marketplace-ui-common/collections/hooks/useCollections';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { getThemesStorefrontRoute } from '../../utils/urls';
import CollectionCard from './ThemeCollectionCard';
import { getIsInApp } from '../../selectors/app';
import { resultCardStyles } from '../../storefront/utils/resultCardStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_COLLECTIONS_PER_PAGE = 24;
const StyledCollectionCard = styled(CollectionCard).withConfig({
  displayName: "ThemeCollectionsSection__StyledCollectionCard",
  componentId: "i3e7bz-0"
})(["", ""], resultCardStyles);
const StyledRouterLink = styled(UIRouterLink).withConfig({
  displayName: "ThemeCollectionsSection__StyledRouterLink",
  componentId: "i3e7bz-1"
})(["display:flex;align-items:stretch;"]);
export default function ThemeCollectionsSection({
  trackInteraction
}) {
  const isInApp = useSelector(getIsInApp);
  const {
    getDisplayedCollections,
    requestState
  } = useCollections({
    appContext: isInApp ? 'app' : 'public',
    offeringType: 'THEME'
  });
  const {
    columns
  } = useResponsiveProps({
    columns: {
      [ScreenSizes.SM]: 1,
      [ScreenSizes.MD]: 2,
      [ScreenSizes.LG]: 3
    }
  });
  const [page, setPage] = useState(1);
  const displayedCollections = getDisplayedCollections();
  const offset = (page - 1) * MAX_COLLECTIONS_PER_PAGE;
  const limit = displayedCollections.length && displayedCollections.length <= MAX_COLLECTIONS_PER_PAGE * page ? displayedCollections.length : offset + MAX_COLLECTIONS_PER_PAGE;
  const currentCollections = displayedCollections.slice(offset, limit);
  const pageCount = Math.ceil(displayedCollections.length / MAX_COLLECTIONS_PER_PAGE);
  const needsPagination = pageCount > 1;
  const handlePageChange = useCallback(newPage => {
    setPage(newPage);
    trackInteraction('change collections page', {
      page: newPage
    });
  }, [trackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(LoadingWrapper, {
      requestStatus: requestState,
      children: /*#__PURE__*/_jsx(UICardGrid, {
        columns: columns,
        className: "p-bottom-10 p-x-5 m-x-15",
        children: currentCollections.map((collection, index) => collection.publishedListing && /*#__PURE__*/_jsx(StyledRouterLink, {
          to: getThemesStorefrontRoute(collection.publishedListing.slug),
          use: "unstyled",
          children: /*#__PURE__*/_jsx(StyledCollectionCard, {
            collection: collection
          })
        }, `collection-${collection.id}-${index}`))
      })
    }), needsPagination && /*#__PURE__*/_jsx(UIPaginator, {
      onPageChange: ({
        target: {
          value
        }
      }) => handlePageChange(value),
      pageCount: pageCount
    })]
  });
}